import about from './about'
import article from './article'
import {Articles} from './articles'
import contact from './contact'
import contentpage from './contentpage'
import error404 from './error404'
import event from './eventdetail'
import {Events} from './events'
import home from './home'
import {Members} from './members'
import page from './page'
import policies from './policies'
import {Projects} from './projects'
import publication from './publication'
import {Publications} from './publications'
import search from './search'
import subscribe from './subscribe'
import theme from './theme'

export default {
	about,
	article,
	publication,
	event,
	contact,
	content_page: contentpage,
	homepage: home,
	page,
	policies,
	search,
	subscribe,
	policy_domain: theme,
	policy_area: theme,
	sector: theme,
	error404,
	category: error404,
	member: error404,
	members: Members,
	publications: Publications,
	events: Events,
	articles: Articles,
	projects: Projects,
	private_events: error404
}
